module.exports = __webpack_public_path__ + "static/img/8.7e38a61.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/8.gif
// module id = Xy10
// module chunks = 0